webpackJsonp([0],{

/***/ "/LQY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0zpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_18_about_me_vue__ = __webpack_require__("SuJ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dab455ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_18_about_me_vue__ = __webpack_require__("GfB3");
function injectStyle (ssrContext) {
  __webpack_require__("lHLU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dab455ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_18_about_me_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dab455ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_18_about_me_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27WV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("PHP and Heroku")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("October 25, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n    This article will serve as a quick reference guide to setting up your PHP application and database to be served over Heroku. There will be a few items that you will need to install to make this process easier. The first of these is a package manager for PHP named Composer. Much like npm for JavaScript, Composer will help you install cool packages to make your application better and will automatically install the dependencies these packages will require. This article will assume you have a working local PostgreSQL database and a working directory with at least an index.php file that you are using to query information from the database.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    There are many different database management systems available today, but for the sake of this article I am assuming you are familiar with PostgreSQL. Likewise, I am assuming that you'll be utilizing PSequel as a GUI to manage our database.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    First, you'll need to travel on over to the Heroku website and set up your\n    account.\n    ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.heroku.com"}},[_vm._v("Heroku")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Next you will need to create a new app on your Heroku account. Application names on Heroku are first come, first serve, and the name will eventually be a part of the web URL used to access your application.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    After creating the app, navigate to the Resources tab within the application and enter the following into the search bar located in the Add-ons section:\n    ")]),_vm._v(" "),_c('code',[_vm._v("postgres")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Select Heroku Postgres from the dropdown and a popup window will appear asking what plan you would like to use. We will be covering the Hobby Dev - Free version only. Click the Provision button to add this feature. If you would like to upgrade to a paid plan, doing some research on the Heroku website would be strongly advised.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    Now navigate to the Settings tab within your application and in the Config Variables section click the Reveal Config Vars button. You will notice a \"DATABASE_URL\" field with a URL field next to it containing the Heroku URL for your database. Take note of this URL as we'll be using it later.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    In your index.php file in your working directory, in the PHP section of your application where you are setting your local database url, add the following code (note, this is where you'll need that database URL from the Settings tab of your Heroku app, not the exact URL listed below):\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    $raw_url = 'postgres://really.big.string.of.garbled.letters/numbers.you.copied.from.DATABASE_URL.on.Heroku';\n\n    $url = parse_url($raw_url);\n\n    var_dump($url);\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Save your file and reload your page in your browser, you'll now see an array being displayed near the top of your page displaying some easy-to-read information about your remote database URL. Open PSequel and open a new window. Click \"Add Connection\" in the bottom left of the screen. Name this something appropriate appended by \"for Heroku\" so you can remember this is your remote database and not your local one. We'll now need to fill in the URL information we dumped to our browser. Simply copy/paste from and into the appropriate fields in PSequel. Note that you will need to remove the \"/\" from the \"Database:\" portion. Now put a check in the Use SSL tickbox, you will not need to fill any of this information out.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Click Connect in the bottom right of the screen and you're now connected to your remote database hosted on Heroku!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Now open a new browser tab and download and install Composer globally from here: "),_c('a',{attrs:{"href":"https://getcomposer.org/"}},[_vm._v("Composer")]),_vm._v(" Make sure to follow directions to do a global install here, as some of the commands we issue will not work correctly if not globally installed.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Now, in terminal within your project working directory, type the following:\n    ")]),_vm._v(" "),_c('code',[_vm._v("composer require vlucas/phpdotenv")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    A few more commands to enter in terminal while we are here:\n    ")]),_vm._v(" "),_c('code',[_vm._v("touch .gitignore")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("touch .env")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("touch .env.sample")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Open .gitignore in your text editor of choice and add the following lines:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    /vendor\n    .env\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Open .env.sample in your text editor of choice and add the following line:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    DATABASE_URL=postgres://user:password@host:port/database\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Copy this line into your .env file and then change the user, password, host, port, and database sections to match your local database URL.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    All of this work is going to allow us to have two seperate copies of our code and database, one local and one remote hosted on Heroku. We will now set up our code so that it will automatically default to our local database for development and default to our remote for the production application.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    First, we will add an if statement to our index.php file within the same function we are using to set the database URL:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    if (file_exists('.env')) {\n      require __DIR__ . '/vendor/autoload.php';\n      $dotenv = new Dotenv\\Dotenv(__DIR__);\n      $dotenv->load();\n    }\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Now we will need to remove the $raw_url variable line and change our $url variable line to read as follows:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    $url = parse_url(getenv(\"DATABASE_URL\"));\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Now we just need to add a Procfile to our working directory so Heroku knows how to build our app. In your project working directory in terminal type:\n    ")]),_vm._v(" "),_c('code',[_vm._v("touch Procfile")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Open Procfile in your text editor and add the following line:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    web: vendor/bin/heroku-php-nginx\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Now add, commit, and push to your Github repo. In your browser, navigate to your newly created app in Personal Apps tab. Open the "),_c('b',[_vm._v("Deploy")]),_vm._v(" tab and scroll to the bottom and copy the line below \"Existing Git Repo\", paste into terminal, and execute. Note that there is a $ in this line, don't copy that or it wont work, that's just letting you know to copy/paste this line into terminal.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    You can now deploy to Heroku by using the following command in terminal:\n    ")]),_vm._v(" "),_c('code',[_vm._v("git push heroku master")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2CtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postBrowserSync'
});

/***/ }),

/***/ "2nQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postStartBootcamp'
});

/***/ }),

/***/ "2wuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__ = __webpack_require__("wmoW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f49f07e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__ = __webpack_require__("gc5K");
function injectStyle (ssrContext) {
  __webpack_require__("Npr/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f49f07e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f49f07e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Dl/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("Using Heroku to Host Your Apps")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("October 2, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n    This article will assume you have the basics of building some type\n    of application or web page that you'd like to be available to the whole\n    of the internet. You just need a place to store it. Maybe it's a small\n    project like my calculator or tic-tac-toe built with Javascript, or maybe\n    something a bit more. It really doesn't matter, as what we'll cover here\n    is getting what you need to deploy your app to Heroku.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Heroku is a free service that will allow you to store up to 5 apps, with \n    more support and app slots available for a small fee. For now we will\n    focus on the free stuff, who doesn't love free?!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    First, you'll need to travel on over to the Heroku website and set up your\n    account.\n    ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.heroku.com"}},[_vm._v("Heroku")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Next you will need to have a local git repo with at bare minimum an index.html\n    file stored within it for Heroku to serve your app to the wilds of the internet.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    If you don't already have this repo stored on Github, now is the time to do so.\n    Create a new repo on Github, click the green Clone or Download button and copy\n    the web url listed below it.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    Open terminal and navigate to your repo directory, for the sake of this article\n    my repo is named \"my-example-app\". Set your remote with the copied url:\n    ")]),_vm._v(" "),_c('code',[_vm._v("git remote add origin https://github.com/username/my-example-app")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Create an index.js file so Heroku will know what to do:\n    ")]),_vm._v(" "),_c('code',[_vm._v("touch index.js")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Let's create a .gitignore file too, there are some items we will be creating\n    that we don't need to push to Github or Heroku:\n    ")]),_vm._v(" "),_c('code',[_vm._v("touch .gitignore")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    And one more, a Procfile for Heroku, note there is no file extension, and capitalization is important:\n    ")]),_vm._v(" "),_c('code',[_vm._v("touch Procfile")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Open your text editor of choice and lets populate these files with what they need.\n    Inside index.js, copy the following and save:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    var express = require('express');\n    var app = express();\n    var port = process.env.PORT || 3000;\n\n    app.use(express.static(__dirname + '/app/'));\n\n    app.listen(port, function() {\n    console.log('I am listening on port 3000!');\n    });\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Basically this tells Heroku we'll be using an Express framework for node.js to\n    run our application. The port option is so you can open a local copy of the app\n    in your browser if you so choose, good for working on styling options, etc. Although you'd probably be better off installing "),_c('b',[_vm._v("live-server")]),_vm._v(" golbally with "),_c('b',[_vm._v("npm")]),_vm._v(" as it will do live reloads of the page as you edit and save files.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    An important note about line 5 of our index.js, the app.use line. The portion containing /app/ will be the directory that your application's index.html lives. This needs to be edited accordingly. For example, if your index.hmtl is in the root directory of your repo a single / would suffice. If it's located in a directory named "),_c('b',[_vm._v("dist")]),_vm._v(" then /app/ would need to be changed to /dist/\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    Now we'll add some bits into the .gitignore file. This will prevent the files we are about to install from being pushed to Github and Heroku in the near future:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    .DS_Store\n    node_modules\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Now lets add a single line to the Procfile, this is basically a script that tells Heroku to execute our index.js file:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("web: node index.js")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Once again an important note. This single line expects index.js to be located in the root directory of your project, in my case "),_c('b',[_vm._v("my-example-app")]),_vm._v(". If you move the index.js file to a subdirectory this line will need to be edited to reflect that change. For example if you moved it to your "),_c('b',[_vm._v("app")]),_vm._v(" directory, this line would need to read "),_c('b',[_vm._v("web: node app/index.js")])]),_vm._v(" "),_c('p',[_vm._v("\n      \n    NPM time! If you dont have npm installed there are plenty of helpful articles online explaining the install process. NPM is a package manager for JavaScript and makes installing things we regularly need a painless process. It is required here: "),_c('a',{attrs:{"href":"https://www.npmjs.com/"}},[_vm._v("NPM")]),_vm._v(".\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    Now lets install some stuff! In terminal, once again in the root directory of your app repo, type the following:\n    ")]),_vm._v(" "),_c('code',[_vm._v("npm init")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Once started you will be asked to reply to some questions, you may skip them by hitting enter or answer them so your package.json that NPM creates has relevant information in it.\n    Now that NPM is initialized, lets install express. Type the following in terminal:\n    ")]),_vm._v(" "),_c('code',[_vm._v("npm install express --save")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Time to once again hit the Heroku website. Under Personal Apps tab, click the "),_c('b',[_vm._v("New")]),_vm._v(" button. You'll be required to specify a name and choose a region. Names for Heroku apps are first come - first serve, so if prompted that the name is taken simply pick something else! This name will soon be part of the url used to access our deployed application!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    After creating the app, if not already, navigate to your newly created app in Personal Apps tab. Open the "),_c('b',[_vm._v("Deploy")]),_vm._v(" tab and scroll to the bottom and copy the line below \"Existing Git Repo\", paste into terminal, and execute. Note that there is a $ in this line, don't copy that or it wont work, that's just letting you know to copy/paste this line into terminal.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    We're so close now! Just run your normal git commands to add, commit and push your added-to repo:\n    ")]),_vm._v(" "),_c('code',[_vm._v("git add ."),_c('br')]),_vm._v(" "),_c('code',[_vm._v("git commit -m \"your commit message goes here\""),_c('br')]),_vm._v(" "),_c('code',[_vm._v("git push origin master")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Now for the Heroku portion. Pushing to Heroku works almost exactly like pushing to Github, and is therefor extremely easy!\n    ")]),_vm._v(" "),_c('code',[_vm._v("git push heroku master")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    That's it! You can watch as your application gets built and deployed in the terminal, and sans any build errors you are now on your way to a web app! If there are build errors, be sure to check the Logs section of your application on the Heroku site and note any build errors that may be present in Terminal for googling solutions.\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3rB1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6+aJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("iTc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5637e315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("M2qu");
function injectStyle (ssrContext) {
  __webpack_require__("/LQY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5637e315"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5637e315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6qKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"https://github.com/joncgrubb"}},[_c('i',{staticClass:"fa fa-github",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/joncgrubb"}},[_c('i',{staticClass:"fa fa-linkedin-square",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://stackoverflow.com/users/8508292/joncgrubb"}},[_c('i',{staticClass:"fa fa-stack-overflow",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/definitely.not.grubb/"}},[_c('i',{staticClass:"fa fa-instagram",attrs:{"aria-hidden":"true"}})]),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"grubbfoot"}},[_c('i',{staticClass:"fa fa-copyright",attrs:{"id":"copy","aria-hidden":"true"}}),_c('p',[_vm._v("Jonathan Grubb  2017")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8z1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bv5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e874e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("qst1");
function injectStyle (ssrContext) {
  __webpack_require__("irNt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40e874e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e874e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EPpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2018_01_20_HTTP_Tunneling_with_ngrok_vue__ = __webpack_require__("Ep9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381593d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2018_01_20_HTTP_Tunneling_with_ngrok_vue__ = __webpack_require__("Uu/K");
function injectStyle (ssrContext) {
  __webpack_require__("ERxm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-381593d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2018_01_20_HTTP_Tunneling_with_ngrok_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381593d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2018_01_20_HTTP_Tunneling_with_ngrok_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ERxm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ep9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postNgrok'
});

/***/ }),

/***/ "FzIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("Enabling BrowserSync in Your Laravel Project")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("November 11, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n\n    If you're like me, clicking the refresh page button in your browser for the 200th time while working on a local project eventually gets to be too much. After searching a variety of different combinations of \"live reload laravel\", \"laravel browsersync\" and the like, I was finally able to piece together how to get automatic page refresh working locally within my Laravel project. The official documentation is mostly great and informative but, especially for developers new to the framework, getting live reload working isn't exactly spelled out for you.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    This is the quickest way to get Browsersync working on your local Laravel project. This framework offers loads of customization, so this post is tailored to new developers and students just looking for a much needed break from that refresh page button.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    I'm assuming since you've found this post that you have a basic understanding of the framework and of package managers and installing development software on your Mac. For this example we'll be making use of Homebrew, npm, and obviously Laravel.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Web devlopers just "),_c('i',[_vm._v("love")]),_vm._v(" our package managers, so if you don't have Yarn, you'll need it (Laravel makes use of it anyway, so now is a good time to install it).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    We will take care of global installation of Yarn so you won't have any trouble with new projects in the future. Open terminal and use Homebrew to install it:\n    ")]),_vm._v(" "),_c('code',[_vm._v("brew install yarn")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Whether you have an existing Laravel project or need to create a new one, these steps will not change (other than installing the prerequisite applications that we're covering now). Assuming you have an existing project and you haven't done so already, navigate to your project root directory in terminal and enter:\n    ")]),_vm._v(" "),_c('code',[_vm._v("npm install")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    This will install the dependencies that Laravel needs to serve your page with Browsersync and doesn't install automatically on creating a new project as with Composer packages.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    Now, with your favorite text editor, open the "),_c('b',[_vm._v("webpack.mix.js")]),_vm._v(" file located in your Laravel project root directory. We will need to edit one of these lines to include browsersync in a way that will work for us. Below is what the lines we need to modify should look like (at least for version 5.5 of Laravel) after a fresh new project has been started:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    mix.js('resources/assets/js/app.js', 'public/js')\n     .sass('resources/assets/sass/app.scss', 'public/css');\n     ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Edit it to now look like this:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    mix.js('resources/assets/js/app.js', 'public/js')\n       .sass('resources/assets/sass/app.scss', 'public/css')\n       .browserSync('http://localhost:8000');\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    You will notice that the URL in the line we added is the exact URL (and port) that "),_c('b',[_vm._v("php artisan serve")]),_vm._v(" utilizes for working on our application locally by default. We won't need to use that URL anymore in our browser for working locally!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Now open your local server like you would normally with artisan by entering into terminal:\n    ")]),_vm._v(" "),_c('code',[_vm._v("php artisan serve")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    You'll need to open another terminal tab at this point, as we'll actually be utilizing two seperate local servers (which is what we require for live reload!)\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Now you'll need to run another command in terminal. Note that this command may have to be run twice, as the first time you run it may just install dependencies required for the Mix to compile. So if you get errors, just run the same command once more before Googling error messages. In terminal:\n    ")]),_vm._v(" "),_c('code',[_vm._v("npm run watch")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Once this command runs successfully it should automagically open a new browser tab of a localhost server in your browser that will update any time you save a file within your Laravel project! Now that refresh page button can rest, finally.\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GZWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GfB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("A little about me...")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("September 18, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n      Who am I? My name is Jonathan, although most people refer to me by my last name. If I had to describe myself in one word, it would have to be \"philomath\". From a young age I've had an undending desire to learn, to know how and why things work, and an urge to modify or customize just about everything. I've been in the automotive industry most of my life, with some of my early time spent at the Toyota manufacturing plant in Georgetown, KY. Other than acquiring a great sense of work ethic at a young age from my time there, I also learned about Kaizen. It's become a pretty common buzzword in the professional world for good reason, continuous improvement is a fantastic philosophy. Kaizen is also the reason for my physical and mental "),_c('i',[_vm._v("need")]),_vm._v(" to modify everything in my life.\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GyPD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I/mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_25_PHP_and_Heroku_vue__ = __webpack_require__("imKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de76a68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_25_PHP_and_Heroku_vue__ = __webpack_require__("27WV");
function injectStyle (ssrContext) {
  __webpack_require__("w2jC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6de76a68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_25_PHP_and_Heroku_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de76a68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_25_PHP_and_Heroku_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDyo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LqI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postHerokuApp'
});

/***/ }),

/***/ "M2qu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('grubbHeader'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"card-navs"},[_c('button',{staticClass:"btn btn-default",class:{ active: _vm.about },on:{"click":_vm.getAbout}},[_c('h1',[_vm._v("About")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.portfolio },on:{"click":_vm.getPortfolio}},[_c('h1',[_vm._v("Portfolio")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.blog },on:{"click":_vm.getBlog}},[_c('h1',[_vm._v("Blog")])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"main-panel"}},[_c('div',{staticClass:"panel-body"},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.about == true)?_c('about'):_vm._e(),_vm._v(" "),(_vm.portfolio == true)?_c('portfolio'):_vm._e(),_vm._v(" "),(_vm.blog == true)?_c('blog'):_vm._e()],1)],1)])]),_vm._v(" "),_c('grubbFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39eee5f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GyPD");
function injectStyle (ssrContext) {
  __webpack_require__("Qnhx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39eee5f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Npr/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postBabel'
});

/***/ }),

/***/ "Qnhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SuJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postAboutMe'
});

/***/ }),

/***/ "T19t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_portfolio_vue__ = __webpack_require__("VE18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d50f1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_vue__ = __webpack_require__("fSY8");
function injectStyle (ssrContext) {
  __webpack_require__("llzn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69d50f1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d50f1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T5Ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postFirstWeek'
});

/***/ }),

/***/ "UJfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about'
});

/***/ }),

/***/ "UKX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_10_Babel_vue__ = __webpack_require__("PJow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21791439_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_10_Babel_vue__ = __webpack_require__("afSM");
function injectStyle (ssrContext) {
  __webpack_require__("8z1C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21791439"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_10_Babel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21791439_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_10_Babel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uu/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("HTTP Tunneling with ngrok")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("January 20, 2018")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n\n    When building applications that utilize the Twilio Voice or SMS API, you will need to handle incoming messages and calls as well as be able to respond to them. In the development environment running on localhost, this poses a few challenges for us. While testing these features we will need the Twilio service to be able to \"talk\" with our local machine. This is referred to as a tunnel. There are many ways we could go about doing this, some safer than others, but as the title of this post suggests, we will be using a simple little tool called ngrok (pronounced 'en-grok', as per the author).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Pop over to the ngrok website and download the tool: "),_c('a',{attrs:{"href":"https://ngrok.com/download"}},[_vm._v("Here")])]),_vm._v(" "),_c('p',[_vm._v("\n\n    The tool has extremely good documentation which I won't repeat here, and the author has some great blog posts about writing good documentation that I highly recommend reading if you have the chance.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    It is extremely simple to start using ngrok to open your project up to the internet, and even monitor the traffic coming and going from your local project. Simply open the terminal and enter:\n    ")]),_vm._v(" "),_c('code',[_vm._v("./ngrok http 8080")]),_vm._v(" "),_c('p',[_vm._v("\n\n    You will need to leave this terminal window open for the tool to continue to function, and you'll be able to see API requests coming through. If you'd like to utilize the debugging features of ngrok, open a browser tab and enter:\n    ")]),_vm._v(" "),_c('code',[_vm._v("localhost:4040")]),_vm._v(" "),_c('p',[_vm._v("\n\n    This is the web interface you can use for debugging, extremely useful if you're integrating Twilio into a Laravel or PHP project where debugging can be a bit more difficult for beginners.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    I wanted to share this tool and a small how-to before my next post which will cover integrating a voice message to users attempting to call in to your Twilio long number. Setting up ngrok is a requirement for allowing this to work locally.\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VE18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portfolio'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main__ = __webpack_require__("6+aJ");



// import HelloWorld from '@/components/HelloWorld'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'grubbMain',
    component: __WEBPACK_IMPORTED_MODULE_2__components_main__["a" /* default */]
  }]
}));

/***/ }),

/***/ "afSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("Quick Babel Explanation")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("October 10, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n      \n    This is a quick and dirty rundown of Babel.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Babel is, at its core, a transpiler. It basically takes code written in ES6 and converts it to ES5 so your browser understands your code. This does introduce some limitations, as not all ES6 code can be transpiled into something that can be reproduced in ES5.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    For the purposes of playing with ES6 code within our browser in bootcamp, Babel has a few different ways we can implement it. With the most current version, the devs have modularized the entire package so that developers can pick and choose only what they actually need. This does make it a little more complicated for new developers, as there are now extra steps that have to be taken to get Babel up and running.\n    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Babel-standalone")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_c('br'),_vm._v("  \n    Add the following to your HTML document:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    "),_vm._v("\n    <script src=\"https://unpkg.com/babel-standalone@6/babel.min.js\"></script>\n    ")])]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Install the env preset locally inside our project directory which allows the ES6 to be converted to ES5:\n    ")]),_vm._v(" "),_c('code',[_vm._v("\n    npm install babel-preset-env --save-dev\n    ")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n    Now we have to create a "),_c('code',[_vm._v(".bablerc")]),_vm._v(" file inside of our project directory and enter the following code inside the file:\n    ")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("\n    {\n      \"presets\": [\"env\"]\n    }\n    ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grubbFooter',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "fSY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('p',{staticClass:"text-center portfolio-title"},[_c('b',[_vm._v("A few of the awesome apps I've built...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://www.link-sling.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-commenting",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Link-Sling")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://grubb-tic-tac-toe.herokuapp.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-hashtag",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Tic Tac Toe")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://grubb-weather-doom.herokuapp.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-sun-o",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Weather Doom")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://grubb-ice-cream.herokuapp.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-shopping-bag",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Ice Cream Shop")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://grubb-connect-4.herokuapp.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-gamepad",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Connect 4")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 text-center"},[_c('a',{attrs:{"href":"https://grubb-sorting-hat.herokuapp.com/","target":"_blank"}},[_c('button',{staticClass:"btn btn-default hvr-radial-out"},[_c('i',{staticClass:"fa fa-address-book",attrs:{"aria-hidden":"true"}})])]),_c('p',[_vm._v("Sorting Hat")])])]),_vm._v(" "),_c('div',{staticClass:"bottom"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gc5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',[_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("January 20, 2018")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("When building applications that utilize the Twilio Voice or SMS API, you will need to handle incoming messages and calls as well as be able to respond to them. In the development environment running on localhost, this poses a few challenges for us. While testing these features we will need the Twilio service...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost8}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("November 11, 2017")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("If you're like me, clicking the refresh page button in your browser for the 200th time while working on a local project eventually gets to be too much. After searching a variety of different combinations of \"live reload laravel\", \"laravel browsersync\" and the like, I was finally able to piece...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost7}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("October 25, 2017")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("This article will serve as a quick reference guide to setting up your PHP application and database to be served over Heroku. There will be a few items that you will need to install to make this process easier. The first of these is a package manager for PHP named...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost6}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("October 10, 2017")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("This is a quick and dirty rundown of Babel. Babel is, at its core, a transpiler. It basically takes code written in ES6 and converts it to ES5 so your browser understands your code. This does introduce some limitations, as not all ES6 code can be transpiled into something that...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost5}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("October 2, 2017")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("This article will assume you have the basics of building some type of application or web page that you'd like to be available to the whole of the internet. You just need a place to store it. Maybe it's a small project like my calculator or tic-tac-toe built with Javascript,...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost4}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("September 24, 2017")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("- Command line - Git - Github - Github Pages - HTML - CSS - node - npm - Bootstrap - SASS - Jekyll - Gulp - Heroku That would be 13 technologies introduced in just the first week! Whew. Thankfully I grew up on DOS machines and command line...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost3}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("September 23, 2017")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("Joining a bootcamp for web development has been something I've thought about in the past and, somehow, just never really got around to looking into, let alone applying for. That all changed about 3 months ago. I had recently moved back to Central Kentucky after about a year of work...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost2}},[_vm._v("Read More")])]),_vm._v(" "),_c('li',{staticClass:"post-list"},[_c('p',{staticClass:"post-date"},[_vm._v("September 18, 2017")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',{staticClass:"post-blurb"},[_vm._v("Who am I? My name is Jonathan, although most people refer to me by my last name. If I had to describe myself in one word, it would have to be \"philomath\". From a young age I've had an undending desire to learn...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-md",attrs:{"type":"button","data-toggle":"modal","data-target":"#myModal"},on:{"click":_vm.getPost1}},[_vm._v("Read More")])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"myModal","role":"dialog"}},[_c('div',{staticClass:"modal-admin"},[_c('div',{staticClass:"modal-content"},[(_vm.post1 == true)?_c('postAboutMe'):_vm._e(),_vm._v(" "),(_vm.post2 == true)?_c('postStartBootcamp'):_vm._e(),_vm._v(" "),(_vm.post3 == true)?_c('postFirstWeek'):_vm._e(),_vm._v(" "),(_vm.post4 == true)?_c('postHerokuApp'):_vm._e(),_vm._v(" "),(_vm.post5 == true)?_c('postBabel'):_vm._e(),_vm._v(" "),(_vm.post6 == true)?_c('postPhpAndHeroku'):_vm._e(),_vm._v(" "),(_vm.post7 == true)?_c('postBrowserSync'):_vm._e(),_vm._v(" "),(_vm.post8 == true)?_c('postNgrok'):_vm._e(),_vm._v(" "),_vm._m(9)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center blog-title"},[_c('b',[_vm._v("Bootcamp experience. Technical Articles. Automotive Coverage.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("HTTP Tunneling with ngrok")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("Enabling BrowserSync in Your Laravel Project")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("PHP and Heroku")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("Babel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("Using Heroku to Host Your Apps")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("First Week Complete")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("The Start of Bootcamp")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"post-title"},[_c('b',[_vm._v("About Me")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iTc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_vue__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_vue__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__about_vue__ = __webpack_require__("zRCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__portfolio_vue__ = __webpack_require__("T19t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blog_vue__ = __webpack_require__("2wuS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grubbMain',
  components: {
    'grubbHeader': __WEBPACK_IMPORTED_MODULE_0__header_vue__["a" /* default */],
    'grubbFooter': __WEBPACK_IMPORTED_MODULE_1__footer_vue__["a" /* default */],
    'about': __WEBPACK_IMPORTED_MODULE_2__about_vue__["a" /* default */],
    'portfolio': __WEBPACK_IMPORTED_MODULE_3__portfolio_vue__["a" /* default */],
    'blog': __WEBPACK_IMPORTED_MODULE_4__blog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      about: true,
      portfolio: false,
      blog: false
    };
  },

  methods: {
    getAbout: function getAbout() {
      this.portfolio = false;
      this.blog = false;
      this.about = true;
    },
    getPortfolio: function getPortfolio() {
      this.blog = false;
      this.about = false;
      this.portfolio = true;
    },
    getBlog: function getBlog() {
      this.about = false;
      this.portfolio = false;
      this.blog = true;
    }
  }
});

/***/ }),

/***/ "imKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postPhpAndHeroku'
});

/***/ }),

/***/ "irNt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivKz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jE+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("First Week Complete!")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("September 24, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('ul',[_c('li',[_vm._v("Command line")]),_vm._v(" "),_c('li',[_vm._v("Git")]),_vm._v(" "),_c('li',[_vm._v("Github")]),_vm._v(" "),_c('li',[_vm._v("Github Pages")]),_vm._v(" "),_c('li',[_vm._v("HTML")]),_vm._v(" "),_c('li',[_vm._v("CSS")]),_vm._v(" "),_c('li',[_vm._v("node")]),_vm._v(" "),_c('li',[_vm._v("npm")]),_vm._v(" "),_c('li',[_vm._v("Bootstrap")]),_vm._v(" "),_c('li',[_vm._v("SASS")]),_vm._v(" "),_c('li',[_vm._v("Jekyll")]),_vm._v(" "),_c('li',[_vm._v("Gulp")]),_vm._v(" "),_c('li',[_vm._v("Heroku")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n\n    That would be 13 technologies introduced in just the first week! Whew. \n    Thankfully I grew up on DOS machines and command line has continued to\n    be useful for troubleshooting on Windows machines ever since, so using\n    the command line on a UNIX system was basically just reconditioning my\n    brain for the difference in commands. Really, the same goes for HTML and\n    CSS. Both were technologies I dabbled with for fun growing up and never\n    really forgot, just like riding a bike! The rest, however, were going to\n    have to be learned... and quickly.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    At first it seemed crazy to me that our instructors would introduce new\n    technologies every single day while I was still trying to wrap my\n    head around what we had learned an hour ago. This is where that \"learning\n    how to learn\" phrase really came into play. All of this tech, while new to\n    me, would make things easier for me in the long run. For example, that \n    simple little website I set up for prework and spent literal "),_c('i',[_vm._v("days")]),_vm._v(" \n    fiddling with CSS elements on would have taken me minutes after learning\n    more about Bootstrap and SASS, not to mention setting up a Gulp workflow\n    to automate repetitive tasks (and its built on JavaScript! I got my\n    intro to JS without even realizing it!).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    We set up package managers like Homebrew and npm to help us get started\n    down this new path of becoming a full stack web developer. We learned\n    about node and hosting our apps on Heroku. We set up our homepages (yes, \n    the one you're visiting right now!) with Github Pages. By the end of \n    the week I was exhausted, but it wasn't until I had some time to reflect\n    that I realized exactly "),_c('i',[_vm._v("why")]),_vm._v(" so much got crammed into the first week.\n    We needed it. I needed it. All of it. There has not been a single piece of \n    tech that we covered the first week that I didn't need.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n    Here's to next week. Bring it on. I'm ready for more!\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPSn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-me"},[_c('p',{staticClass:"text-center about-title"},[_c('b',[_vm._v("Web Developer. Philomath. Automotive Enthusiast. Awesome Guy.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('img',{staticClass:"profile-pic",attrs:{"src":__webpack_require__("vgol")}}),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("I have an insatiable desire to learn, modify, and improve everything around me. I've loved technology from a young age and have been in the automotive industry for most of my professional career. From coding and writing scripts for gaming addons and bots, to assisting with development of custom android ROMS with the folks over on the xda forums, to hiring, training and leading employees in a brand new market for a national top 10 automotive company, my need to learn, improve, and help others do the same has only gotten stronger.")]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('i',{staticClass:"fa fa-code blurb-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"blurb-title"},[_c('b',[_vm._v("Developer")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("The Awesome Inc web development bootcamp has been a fantastic opportunity for me to break out of my comfort zone in the automotive industry to pursue my dream of becoming an asset in the ever changing technology industry.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('i',{staticClass:"fa fa-wrench blurb-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"blurb-title"},[_c('b',[_vm._v("Enthusiast")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("I helped my best friend build a turbocharged 500 wheel horsepower 1.6 liter 1991 Honda CRX that still managed 40+ mpg while not on boost. My current project is a 2006 Acura TSX that I've outfitted with extremely rare Japan-only parts for the car show scene.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('i',{staticClass:"fa fa-mobile blurb-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"blurb-title"},[_c('b',[_vm._v("Philomath")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("I'm a lifelong learner. Everything I become interested in becomes a hobby to me in some form or fashion. Mobile phones, cooking, home automation... I never turn down an opportunity to research something new, especially if it means the need for buying new tools.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHLU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "llzn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lxpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_11_01_BrowserSync_With_Laravel_vue__ = __webpack_require__("2CtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7412dc3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_11_01_BrowserSync_With_Laravel_vue__ = __webpack_require__("FzIe");
function injectStyle (ssrContext) {
  __webpack_require__("JDyo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7412dc3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_11_01_BrowserSync_With_Laravel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7412dc3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_11_01_BrowserSync_With_Laravel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb610f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("6qKT");
function injectStyle (ssrContext) {
  __webpack_require__("Bv5z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fb610f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb610f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oM5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-post"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("The Start of Bootcamp")]),_vm._v(" "),_c('h5',{staticClass:"date"},[_vm._v("September 23, 2017")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("\n    Joining a bootcamp for web development has been something I've thought about\n    in the past and, somehow, just never really got around to looking into, let\n    alone applying for. That all changed about 3 months ago. I had recently moved\n    back to Central Kentucky after about a year of work in the automotive\n    industry in Nasville, TN and to say I was glad to be home would be the\n    understatement of a lifetime. Little did I know just how quickly things\n    would progress once I stumbled upon the Awesome Inc website randomly one day.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    The application process was "),_c('i',[_vm._v("extremely")]),_vm._v(" thorough, consisting of multiple\n    challenges (some beginner coding related, others more of a thought\n    process exercise) that had to be completed for a chance at acceptance\n    into the program. I had already completed my application process the\n    day of the open house available to the public about 2 months prior\n    to the planned start date of the bootcamp, and had scheduled my interview\n    for that same day.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      \n    The interview was actually really fun. It was set up just like any job\n    interview I've ever been to, but the questions asked got a little more\n    personal than in my previous experiences. It seemed the team at Awesome\n    Inc University didn't just want capable students, they were also looking\n    for individuals that wanted to make a difference. Besides the questions\n    there was also a technical portion which involved playing a game on a\n    tablet called Lightbot. It seemed strange to me at first until I realized\n    that the game relies on you to interperet the landscape, plan accordingly\n    and then execute your moves to be successful, an ability I have come to\n    realize is extremely important for bootcamp. I was confident, but with \n    only 10-15 people being selected for the program, I was extremely humble \n    about my chances of actually getting in.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n\n    Congratulations! That was the first word of the email I received roughly a month\n    before the bootcamp start date. I remember opening the email and being too afraid\n    to actually scroll down to see what was written for at least 5 minutes. \n    The next month consisted of completing pre-work challenges, watching video\n    content, and generally familiarizing myself with some of the more commonly used\n    current technologies associated with web development (or refamiliarizing myself\n    in the case of HTML and CSS). The prework was much more challenging than those\n    from the application process and in the end I feel they were designed to \n    introduce all of us to the concept on \"learning how to learn\". It may not\n    sound like that big of a deal, but web development and technology in general\n    is in a constant state of Kaizen (or continuous improvement, I can thank\n    Toyota Motor Manufacturing for knowing that one) and requires developers to\n    always be searching for or creating new and easier ways to perform the task\n    at hand.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n    I'll cover what my first week was like in my next post. It would be putting\n    it "),_c('i',[_vm._v("very")]),_vm._v(" lightly to say that the pre-work was designed so we could all\n    \"hit the ground running\" the first week, but more on that next time!\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qFT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_23_Start_of_Bootcamp_vue__ = __webpack_require__("2nQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f17ca5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_23_Start_of_Bootcamp_vue__ = __webpack_require__("oM5b");
function injectStyle (ssrContext) {
  __webpack_require__("zX5H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f17ca5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_23_Start_of_Bootcamp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f17ca5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_23_Start_of_Bootcamp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qst1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("Jonathan Grubb")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/joncgrubb"}},[_c('i',{staticClass:"fa fa-github",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/joncgrubb"}},[_c('i',{staticClass:"fa fa-linkedin-square",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://stackoverflow.com/users/8508292/joncgrubb"}},[_c('i',{staticClass:"fa fa-stack-overflow",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/definitely.not.grubb/"}},[_c('i',{staticClass:"fa fa-instagram",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_24_First_Week_Complete_vue__ = __webpack_require__("T5Ec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f8b61d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_24_First_Week_Complete_vue__ = __webpack_require__("jE+e");
function injectStyle (ssrContext) {
  __webpack_require__("ivKz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02f8b61d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_09_24_First_Week_Complete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f8b61d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_09_24_First_Week_Complete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uqWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__ = __webpack_require__("LqI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d380ab7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__ = __webpack_require__("3Dl/");
function injectStyle (ssrContext) {
  __webpack_require__("GZWs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d380ab7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d380ab7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vgol":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jon.d93c187.jpg";

/***/ }),

/***/ "w2jC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wmoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__posts_2017_09_18_about_me_vue__ = __webpack_require__("0zpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__posts_2017_09_23_Start_of_Bootcamp_vue__ = __webpack_require__("qFT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__posts_2017_09_24_First_Week_Complete_vue__ = __webpack_require__("tPcm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__posts_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__ = __webpack_require__("uqWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__posts_2017_10_10_Babel_vue__ = __webpack_require__("UKX8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__posts_2017_10_25_PHP_and_Heroku_vue__ = __webpack_require__("I/mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__posts_2017_11_01_BrowserSync_With_Laravel_vue__ = __webpack_require__("lxpK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__posts_2018_01_20_HTTP_Tunneling_with_ngrok_vue__ = __webpack_require__("EPpO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog',
  components: {
    'postAboutMe': __WEBPACK_IMPORTED_MODULE_0__posts_2017_09_18_about_me_vue__["a" /* default */],
    'postStartBootcamp': __WEBPACK_IMPORTED_MODULE_1__posts_2017_09_23_Start_of_Bootcamp_vue__["a" /* default */],
    'postFirstWeek': __WEBPACK_IMPORTED_MODULE_2__posts_2017_09_24_First_Week_Complete_vue__["a" /* default */],
    'postHerokuApp': __WEBPACK_IMPORTED_MODULE_3__posts_2017_10_02_Using_Heroku_to_Host_Your_Apps_vue__["a" /* default */],
    'postBabel': __WEBPACK_IMPORTED_MODULE_4__posts_2017_10_10_Babel_vue__["a" /* default */],
    'postPhpAndHeroku': __WEBPACK_IMPORTED_MODULE_5__posts_2017_10_25_PHP_and_Heroku_vue__["a" /* default */],
    'postBrowserSync': __WEBPACK_IMPORTED_MODULE_6__posts_2017_11_01_BrowserSync_With_Laravel_vue__["a" /* default */],
    'postNgrok': __WEBPACK_IMPORTED_MODULE_7__posts_2018_01_20_HTTP_Tunneling_with_ngrok_vue__["a" /* default */]
  },
  data: function data() {
    return {
      post1: false,
      post2: false,
      post3: false,
      post4: false,
      post5: false,
      post6: false,
      post7: false,
      post8: false
    };
  },

  methods: {
    getPost1: function getPost1() {
      this.post2 = false;
      this.post3 = false;
      this.post4 = false;
      this.post5 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = false;
      this.post1 = true;
    },
    getPost2: function getPost2() {
      this.post1 = false;
      this.post3 = false;
      this.post4 = false;
      this.post5 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = false;
      this.post2 = true;
    },
    getPost3: function getPost3() {
      this.post1 = false;
      this.post2 = false;
      this.post4 = false;
      this.post5 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = false;
      this.post3 = true;
    },
    getPost4: function getPost4() {
      this.post1 = false;
      this.post2 = false;
      this.post3 = false;
      this.post5 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = false;
      this.post4 = true;
    },
    getPost5: function getPost5() {
      this.post1 = false;
      this.post2 = false;
      this.post3 = false;
      this.post4 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = false;
      this.post5 = true;
    },
    getPost6: function getPost6() {
      this.post1 = false;
      this.post2 = false;
      this.post3 = false;
      this.post4 = false;
      this.post5 = false;
      this.post7 = false;
      this.post8 = false;
      this.post6 = true;
    },
    getPost7: function getPost7() {
      this.post1 = false;
      this.post2 = false;
      this.post3 = false;
      this.post4 = false;
      this.post5 = false;
      this.post6 = false;
      this.post8 = false;
      this.post7 = true;
    },
    getPost8: function getPost8() {
      this.post1 = false;
      this.post2 = false;
      this.post3 = false;
      this.post4 = false;
      this.post5 = false;
      this.post6 = false;
      this.post7 = false;
      this.post8 = true;
    }
  }
});

/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grubbHeader',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zRCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("UJfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328180e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("jPSn");
function injectStyle (ssrContext) {
  __webpack_require__("3rB1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-328180e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328180e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zX5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9784f836147ff5642d7b.js